// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInCalendarISOWeeks as fn } from "../differenceInCalendarISOWeeks.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInCalendarISOWeeksWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInCalendarISOWeeksWithOptions;
